import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Pie = styled.footer`
  background: ${({ theme }) => theme.colors.sageDeep};
  color: #f2f0ea;
  margin-top: ${({ theme }) => theme.space.xxl};
`;

const Contenido = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.md};
  display: grid;
  gap: ${({ theme }) => theme.space.lg};
  grid-template-columns: 1fr;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 2fr 1fr 1fr;
  }
`;

const Marca = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 1.4rem;
  margin-bottom: ${({ theme }) => theme.space.sm};
`;

const Texto = styled.p`
  font-size: 0.9rem;
  opacity: 0.85;
  max-width: 40ch;
`;

const Columna = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  h4 {
    font-size: 0.85rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    opacity: 0.7;
    margin-bottom: 0.3rem;
  }

  a {
    font-size: 0.92rem;
    opacity: 0.9;
    transition: opacity 200ms ease;

    &:hover {
      opacity: 1;
      text-decoration: underline;
    }
  }
`;

const Legal = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.15);
  padding: ${({ theme }) => theme.space.md};
  text-align: center;
  font-size: 0.8rem;
  opacity: 0.7;
`;

function Footer() {
  return (
    <Pie>
      <Contenido>
        <div>
          <Marca>numa.</Marca>
          <Texto>
            Estudio boutique de pilates. Grupos pequeños, atención personal y un espacio pensado
            para que te muevas mejor.
          </Texto>
        </div>
        <Columna>
          <h4>Estudio</h4>
          <Link to="/clases">Clases</Link>
          <Link to="/agenda">Agenda</Link>
          <Link to="/paquetes">Paquetes</Link>
          <Link to="/instructores">Instructores</Link>
        </Columna>
        <Columna>
          <h4>Contacto</h4>
          <Link to="/contacto">Ubicación y horarios</Link>
          <a href="https://wa.me/5215500000000" target="_blank" rel="noreferrer">
            WhatsApp
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            Instagram
          </a>
        </Columna>
      </Contenido>
      <Legal>© {new Date().getFullYear()} Numa Pilates · Política de cancelación: 12 horas de anticipación</Legal>
    </Pie>
  );
}

export default Footer;
